import React from 'react';
import { Icon } from '@iconify/react';

export const VideoEditingVisual = () => {
  return (
    <div className="w-[85%] bg-white rounded-lg shadow-lg border border-gray-100 overflow-hidden flex flex-col h-36 relative top-2">
        {/* Preview Area / Script Input */}
        <div className="flex-1 bg-gray-50 relative flex items-center justify-center overflow-hidden group">
            <div className="absolute inset-0 p-3">
                 <div className="flex items-center gap-1.5 mb-2">
                    <Icon icon="mdi:file-document-outline" width={10} className="text-gray-400" />
                    <span className="text-[8px] font-bold text-gray-500">Script Preview</span>
                 </div>
                 <div className="space-y-1.5">
                    <div className="h-1.5 w-full bg-gray-200 rounded-full"></div>
                    <div className="h-1.5 w-3/4 bg-gray-200 rounded-full"></div>
                    <div className="h-1.5 w-5/6 bg-gray-200 rounded-full"></div>
                 </div>
            </div>

            {/* AI Action Overlay */}
            <div className="absolute inset-0 bg-black/5 backdrop-blur-[1px] flex items-center justify-center">
                 <div className="bg-white/90 px-3 py-1.5 rounded-full shadow-lg border border-purple-100 flex items-center gap-1.5 cursor-pointer hover:scale-105 transition-transform">
                    <Icon icon="mdi:magic-staff" width={10} className="text-purple-600" />
                    <span className="text-[9px] font-bold text-gray-700">AI Scene Transition</span>
                 </div>
            </div>
        </div>

        {/* Timeline Area */}
        <div className="h-14 bg-white border-t border-gray-100 p-2 flex flex-col justify-center gap-1.5">
            <div className="flex justify-between items-center text-[8px] text-gray-400 px-1 font-mono">
                <span>00:00</span>
                <span>00:30</span>
            </div>
            <div className="relative h-5 w-full bg-gray-50 rounded flex overflow-hidden ring-1 ring-gray-100">
                <div className="w-[25%] bg-blue-100 border-r border-white/50 flex items-center justify-center text-[6px] text-blue-400 font-bold">INTRO</div>
                <div className="w-[10%] bg-gray-200 border-r border-white/50 flex items-center justify-center">
                    <Icon icon="mdi:content-cut" width={8} className="text-gray-400" />
                </div>
                <div className="w-[45%] bg-purple-100 border-r border-white/50 flex items-center justify-center text-[6px] text-purple-400 font-bold">BODY</div>
                <div className="w-[20%] bg-pink-100 flex items-center justify-center text-[6px] text-pink-400 font-bold">OUTRO</div>

                {/* Scrubber */}
                <div className="absolute top-0 left-[35%] h-full w-0.5 bg-red-500 z-10">
                     <div className="absolute -top-1 -left-1 w-2.5 h-2.5 bg-red-500 rounded-full shadow-sm border border-white flex items-center justify-center"></div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default VideoEditingVisual;
